import React from 'react';
import styled from 'styled-components';
import { ToolForOwnerModel } from 'types/tools/tool-owners/ToolForOwnerModel';
import ToolFieldsGrid from './ToolFieldsGrid';
import getToolTypeLabel from 'util/getToolTypeLabel';
import OldUIReadonlyTextInput from 'components/tools/OldUIReadonlyTextInput';
import OldUIReadonlySelectInput from 'components/tools/OldUIReadonlySelectInput';

interface Props {
  toolData: ToolForOwnerModel;
}

const booleanYesNoOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

const CompanyOwnedToolHead: React.FC<Props> = ({ toolData }) => {
  return (
    <ToolFieldsGrid>
      <Heading className="w-full">General tool information</Heading>

      <OldUIReadonlyTextInput label="Tool name" value={toolData.name} className="w-full" />

      <OldUIReadonlyTextInput label="Tool type" value={getToolTypeLabel(toolData.toolType)} />

      <OldUIReadonlySelectInput
        label="API integration"
        tooltip="Only Fully Pre-verified tools can have an API integration at this time."
        value={booleanYesNoOptions.find((v) => v.value === toolData.hasApiIntegration)}
      />

      <OldUIReadonlySelectInput label="Tool owner" value={toolData.toolOwnerCompany} />

      <OldUIReadonlySelectInput label="Tool owner country" value={toolData.toolOwnerCountry} />

      <OldUIReadonlyTextInput label="Contact Person for the Tool" value={toolData.contactPersonName} />

      <OldUIReadonlyTextInput label="Contact Person Email" value={toolData.contactPersonEmail} />

      <OldUIReadonlyTextInput label="Website" value={toolData.website} />

      <OldUIReadonlyTextInput
        label="Tool Description"
        tooltip="A short summary of what the tool does, its purpose, or any relevant details that help users understand its use."
        value={toolData.description}
      />
    </ToolFieldsGrid>
  );
};

export default CompanyOwnedToolHead;

const Heading = styled.div`
  font-weight: 500;
  font-family: ${(props) => props.theme.fontFamilies.body};
  font-size: 16px;
`;
